import { Action } from 'redux'
import { put, takeLatest, all } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload, IListSearchQueryPaginationPayload } from '@app-store/slices/quotations/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}
interface TaskSearchAction extends Action {
    payload: IListSearchQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure, onRequestSearch, onFailureSearch, onSuccessSearch } =
    rootActions.quotations.list

function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query,
            populates: [
                { path: 'products.product' },
                { path: 'company', select: 'name _id country' },
                { path: 'contact', select: 'firstname lastname jobTitle _id' }
                // { path: 'createdByContact', select: 'firstname lastname _id avatar' }
            ],
            needPopulate: true
        }

        const response = yield axios.get(`/companies/quotations`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}
function* searchSagaTask({ payload }: TaskSearchAction) {
    try {
        const params = {
            ...payload.pagination,
            textSearch: payload.textSearch
        }

        const response = yield axios.get(`/search/rfqs`, {
            params
        })
        if (response.success) {
            yield put(onSuccessSearch(response.result))
        }
    } catch (error) {
        yield put(onFailureSearch(error))
    }
}

function* listSaga(): any {
    yield all([
        takeLatest<TaskAction>(onRequest, listSagaTask),
        takeLatest<TaskSearchAction>(onRequestSearch, searchSagaTask)
    ])
}

export default listSaga
